import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightRichText } from "../../../../modules/content/components/DaylightRichText/DaylightRichText";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          layout="rail"
        />
        <div
          className={cn(
            "grid border-l border-t border-border",
            columns[columnCount || 3],
          )}
        >
          {items.map((item, index) => (
            <article className="border-b border-r border-border p-6 md:p-8" key={index}>
              <span className="daylight-label block text-northsea">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="mt-10 font-daylight-display text-5xl font-bold leading-none tracking-[-0.04em] text-primary md:text-6xl">
                {item.value}
              </p>
              <h3 className="daylight-label mt-6 text-graphite">{item.label}</h3>
              {item.description ? (
                <DaylightRichText
                  className="mt-3 max-w-[32ch] text-sm leading-relaxed text-northsea"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </DaylightSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
